export default __webpack_public_path__ + "static/media/mc_glasses.09cbbb0f.png";